import { appRoutes } from 'constants/navigation';

export const navbarConfig = [
  {
    title: 'Roles',
    path: appRoutes.projects.path,
  },
  {
    title: 'Companies',
    path: appRoutes.companies.path,
  },
  {
    title: 'Users',
    path: appRoutes.users.path,
  },
  {
    title: 'Integrations',
    path: appRoutes.integrations.path,
  },
  {
    title: 'Results',
    path: appRoutes.results.path,
  },
  {
    title: 'Form manager',
    path: appRoutes.formManager.path,
  },
  {
    title: 'Skills',
    path: appRoutes.content.path,
  },
  {
    title: 'Reports',
    path: appRoutes.reports.path,
  },
  {
    title: 'Docs',
    path: appRoutes.docs.path,
  },
];
